/* RSF breadcrumb dynamic parent injection.
   Se l'utente arriva da una brand page (/pages/<handle>), inietta segmento
   "<Brand Page>" nel breadcrumb tra "Home" e il segmento corrente.

   Usa document.referrer (URL della pagina precedente nel browser).
   Persiste il "last brand page" in sessionStorage per coprire navigazioni multi-hop
   (es. brand page → collection → product → altro product).

   Esempio:
     - User: /pages/retrosuperfuture → click Belli → /collections/belli
     - Pre-JS breadcrumb: "Home > Belli"
     - Post-JS:           "Home > Retrosuperfuture > Belli"
*/
(function () {
  const BRAND_PAGES = {
    'retrosuperfuture': 'Retrosuperfuture',
    'marni':            'Marni',
    '8000':             '8000',
    'mm6':              'MM6',
  };

  function detectBrandFromUrl(url) {
    if (!url) return null;
    try {
      const u = new URL(url, location.origin);
      const m = u.pathname.match(/^\/pages\/([^/?#]+)/);
      if (m && BRAND_PAGES[m[1]]) return m[1];
    } catch (e) {}
    return null;
  }

  // Save current brand context to session storage if on brand page
  const currentBrand = detectBrandFromUrl(location.href);
  if (currentBrand) {
    sessionStorage.setItem('rsf_brand_context', currentBrand);
    return; // no need to inject on the brand page itself
  }

  // Pick brand context: prefer recent session value, fallback to referrer
  let brand = sessionStorage.getItem('rsf_brand_context');
  if (!brand) brand = detectBrandFromUrl(document.referrer);

  // Clear context when user navigates to home — fresh start
  if (location.pathname === '/' || location.pathname === '') {
    sessionStorage.removeItem('rsf_brand_context');
    return;
  }

  if (!brand || !BRAND_PAGES[brand]) return;

  function inject() {
    const label = BRAND_PAGES[brand];
    const href = '/pages/' + brand;

    // Collection PLP breadcrumb (snippet rsf-breadcrumb.liquid)
    const plpList = document.querySelector('.rsf-breadcrumb__list');
    if (plpList && !plpList.querySelector(`a[href="${href}"]`)) {
      const homeItem = plpList.querySelector('.rsf-breadcrumb__item');
      const sep = '<span class="rsf-breadcrumb__sep" aria-hidden="true">&gt;</span>';
      const li = document.createElement('li');
      li.className = 'rsf-breadcrumb__item';
      li.innerHTML = `<a href="${href}">${label}</a>${sep}`;
      homeItem?.after(li);
    }

    // PDP breadcrumb (inline in rsf-main-product.liquid: span > a > span > a > span)
    const pdp = document.querySelector('.rsf-pdp-head__breadcrumb');
    if (pdp && !pdp.querySelector(`a[href="${href}"]`)) {
      // First anchor is "Home". Insert after Home's separator.
      const homeAnchor = pdp.querySelector('a[href="/"]');
      const sepAfterHome = homeAnchor?.nextElementSibling; // span sep
      if (sepAfterHome) {
        const a = document.createElement('a');
        a.href = href; a.textContent = label;
        const s = document.createElement('span');
        s.className = 'rsf-pdp-head__breadcrumb-sep';
        s.setAttribute('aria-hidden', 'true');
        s.innerHTML = '&gt;';
        sepAfterHome.after(s);
        sepAfterHome.after(a);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
